import {Component, Input, OnInit} from '@angular/core';
import {BaseProduct} from "../../../services/product.service";
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-extra-info',
  templateUrl: './extra-info.component.html',
  styleUrls: ['./extra-info.component.scss']
})
export class ExtraInfoComponent implements OnInit {
  @Input() product:BaseProduct;
  constructor(private translateService:TranslateService) { }

  ngOnInit() {
  }

}
